(ns net.kestec.mhda-pilgrimage.public.news.news-events
  (:require
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [ajax.core :as ajax]
    [day8.re-frame.http-fx]
    [re-frame.core :as rf]
    ))



(rf/reg-event-fx
  ::load-news
  (fn [{db :db} _]
    {:http-xhrio [{:method          :get
                   :uri             (str "/api/pilgrimage/" (get-in db [::db/me :pilgrimage-id]) "/my-news")
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [::db/set! ::db/my-news]
                   :on-failure      [::db/log-error]}]}))